/**
 * Session-only auth for protected case studies.
 * Not secure against determined users; only hides content from casual viewing.
 */

const CASE_STUDY_AUTH_KEY = 'case-study-auth';

export function isCaseStudyAuthenticated() {
  return typeof sessionStorage !== 'undefined' && sessionStorage.getItem(CASE_STUDY_AUTH_KEY) === 'true';
}

export function setCaseStudyAuthenticated() {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(CASE_STUDY_AUTH_KEY, 'true');
  }
}
